// This is a common constants file
module.exports = {
	DASHBOARD_PANELS: {
		ADMIN: 'admin',
		VIDEO_LIBRARY: 'videoLibrary',
		EXPERIMENT: 'experiment',
		NETWORK_WIDE_SYNC: 'networkWideSync',
		SUPER_ADMIN: 'superAdmin',
		BANNER_FP: 'bannerFp',
		SPLIT_DOC_EDITOR: 'splitDocEditor',
		FVP_CONFIG_EDITOR: 'fvpConfigEditor'
	},
	CONFIG_EDIT_MODES: {
		CREATE: 'CREATE',
		UPDATE: 'UPDATE'
	},
	BANNER_FP_EDIT_MODES: {
		CREATE: 'CREATE_BANNERFP',
		UPDATE: 'UPDATE_BANNERFP'
	},
	FVP_CONFIG_EDIT_MODES: {
		CREATE: 'CREATE_FVP',
		UPDATE: 'UPDATE_FVP'
	},

	cookieConsts: {
		userCookieKey: 'user'
	},
	auditLogElasticServer: {
		path: '/auditlog',
		type: 'INSTREAM',
		appName: 'instream-adhoc-dashboard',
		data: 'Update Config',
		name: 'UPDATE_CONFIG'
	},
	avoidFlatteningKeys: [
		'featuresData.customLabelConfig.textStyles',
		'featuresData.customTargeting.targeting',
		'featuresData.vastDaisyChainingConfig',
		'networkData.gamUprConfig',
		'abSplitTestData',
		'multiSplitTestData'
	],
	PLAYLIST_CONFIG_CDN: 'https://cdn.adpushup.com',
	PLAYLIST_MODES: {
		SITE_LEVEL_UPDATE_PAGE_VIDEOS: 'SITE_LEVEL_UPDATE_PAGE_VIDEOS',
		SITE_LEVEL_CREATE_PAGE_VIDEOS: 'SITE_LEVEL_CREATE_PAGE_VIDEOS',
		UPDATE_PAGE_VIDEOS: 'UPDATE_PAGE_VIDEOS',
		CREATE_PAGE_VIDEOS: 'CREATE_PAGE_VIDEOS',
		SYNC_SINGLE_PAGE_VIDEOS: 'SYNC_SINGLE_PAGE_VIDEOS',
		SYNC_BULK_PAGE_VIDEOS: 'SYNC_BULK_PAGE_VIDEOS'
	},
	SPLIT_DOC_EDIT_MODES: {
		CREATE: 'CREATE_SPLIT_DOC',
		UPDATE: 'UPDATE_SPLIT_DOC',
		SYNC: 'SYNC_SPLIT_DOC'
	},
	TPVAST_CONSTANTS: {
		EDIT_MODES: {
			CREATE: 'CREATE_TPVAST_DOC',
			UPDATE: 'UPDATE_TPVAST_DOC'
		},
		THIRD_PARTY_DEMAND_PARTNERS: ['DEFAULT', 'ADIPOLO', 'AMPLIFYY'],
		INVENTORY: { FLOOR: 'floor', DEMAND: 'demand', PLATFORM: 'platform' },

		TP_VAST_CONFIG_TABS: {
			TP_VAST_CONFIG: 'TP_VAST_CONFIG',
			TP_VAST_REPORTING: 'TP_VAST_REPORTING'
		}
	},
	SCRIPT_TYPES: {
		URL: 'URL',
		SCRIPT: 'SCRIPT',
		HTML: 'HTML'
	},
	SPLIT_DOC_PARAMETERS: {
		ENABLED: 'enabled',
		SITE_ID: 'siteId',
		SITE_DOMAIN: 'siteDomain',
		SCRIPTS: 'scripts',
		TYPE: 'type',
		VALUE: 'value',
		DEFER: 'defer',
		ASYNC: 'async',
		SPLIT_CONFIGS: 'splitConfigs',
		ARCHIVED: 'archived',
		SPLITS: 'splits',
		KEY: 'key',
		SPLIT: 'split'
	},

	PLATFORMS: {
		DESKTOP: 'DESKTOP',
		MOBILE: 'MOBILE',
		TABLET: 'TABLET',
		DEFAULT: 'DEFAULT',
		GLOBAL_PLATFORM: 'GLOBAL_PLATFORM'
	},
	GLOBAL_COUNTRY: 'GLOBAL_COUNTRY',
	FRAMERATE_CONSTANTS: {
		DOMAIN: 'https://cdn.adpushup.com',
		BUNDLE_NAME: 'apInstreamBundle.js'
	},
	PAGE_LEVEL_SCRIPT_CONFIG_CDN: 'https://cdn.adpushup.com',
	PAGE_LEVEL_SCRIPT_CONFIG_MODES: {
		SITE_LEVEL_UPDATE_PAGE_CONFIGS: 'SITE_LEVEL_UPDATE_PAGE_CONFIGS',
		SITE_LEVEL_CREATE_PAGE_CONFIGS: 'SITE_LEVEL_CREATE_PAGE_CONFIGS',
		UPDATE_PAGE_CONFIG: 'UPDATE_PAGE_CONFIG',
		CREATE_PAGE_CONFIG: 'CREATE_PAGE_CONFIG',
		SYNC_SINGLE_PAGE_LEVEL_CONFIG: 'SYNC_SINGLE_PAGE_LEVEL_CONFIG',
		SYNC_BULK_PAGE_LEVEL_CONFIG: 'SYNC_BULK_PAGE_LEVEL_CONFIG',
		PAGE_CONFIG_LOADING: 'PAGE_CONFIG_LOADING',
		PAGE_CONFIG_ERROR: 'PAGE_CONFIG_ERROR',
		PAGE_CONFIG_NOT_FOUND: 'PAGE_CONFIG_NOT_FOUND'
	},
	PAGE_MODES_FOR_PAGE_SETTINGS_TABS: {
		PAGE_LEVEL_SCRIPT_CONFIG: 'PAGE_LEVEL_SCRIPT_CONFIG',
		PAGE_PLAYLIST_CONFIG: 'PAGE_PLAYLIST_CONFIG'
	},
	EXPB_DOC_CONSTANTS: {
		BLOCKERS: {
			SITE_UPDATE: 'SITE_UPDATE',
			SITE_SYNC: 'SITE_SYNC'
		},
		SITE_STATUS: {
			LIVE: 'LIVE',
			CONCLUDED: 'CONCLUDED',
			PAUSED: 'PAUSED'
		},
		EXPERIMENT_SPLIT_TYPES: {
			NETWORK_SPLIT: 'NETWORK_SPLIT',
			PAGE_LEVEL: 'PAGE_LEVEL'
		},
		CONFIG_EDIT_MODES: {
			CREATE: 'EXPB_DOC_CREATE',
			UPDATE: 'EXPB_DOC_UPDATE',
			NOT_FOUND: 'EXPB_DOC_NOT_FOUND',
			SERVER_ERROR: 'EXPB_DOC_SERVER_ERROR'
		}
	},
	MULTI_SPLIT_TEST_CONSTANTS: {
		IDENTIFIER: 'multiSplitTestData',
		KVP_VERSION_MAPPING_WITH_SPLITS: {
			1: '{1}',
			2: '{1 | 2}',
			3: '{1 | 2 | 3}',
			4: '{1 | 2 | 3 | 4}'
		}
	},
	AB_SPLIT_TEST_CONSTANTS: {
		IDENTIFIER: 'abSplitTestData',
		CUSTOM_TARGETING: {
			KEY: 'ab_split_test',
			CONTROL_VALUE: 'control_split',
			EXPERIMENT_VALUE: 'experiment_split'
		},
		AB_SPLIT_TYPE: {
			CONTROL: 'control',
			EXPERIMENT: 'experiment'
		}
	},
	SPLIT_CONFIG_TYPES: {
		EXPERIMENT_SPLIT: 'EXPERIMENT_SPLIT',
		NORMAL_SPLIT: 'NORMAL_SPLIT',
		MULTI_SPLIT: 'MULTI_SPLIT'
	},
	SPLIT_LEVELS: {
		SECTION_LEVEL_SPLIT: 'SECTION_LEVEL_SPLIT',
		SITE_LEVEL_SPLIT: 'SITE_LEVEL_SPLIT'
	},

	SECTION_TYPES: {
		EXPERIMENT_SECTION: 'EXPERIMENT_SECTION',
		CONSUMER_CONFIG_SECTION: 'CONSUMER_CONFIG_SECTION'
	},
	CONFIG_KEYDATA_CONSTANTS: {
		CUSTOM_TARGETING_KEYDATA: 'featuresData.customTargeting',
		PAGEVIEW_PREFIX: '_pv',
		SEC_PV_TARGETING: 'sec_pv_targeting',
		MAPPED_PLAYLIST_DATA: 'mappedPlaylistData',
		DEFAULT_PV: 'default_pv',
		FP_ENGINE_ENABLED_KEY: 'networkData.fpEngineConfig.enabled',
		FP_ENGINE_EXPERIMENT_KEY: 'networkData.fpEngineConfig.experimentNumber',
		FP_ENGINE_CONFIGS_KEY: 'networkData.fpEngineConfig.configs',
		GAM_UPR_CONFIG_KEYDATA: 'networkData.gamUprConfig'
	},
	VIDEO_SECTION_PROPERTIES: {
		SECTION_REF: 'sectionRef'
	},
	// '/register' is a non-redirectable path
	// because users may access it directly
	// We want to keep it away from our custom redirection logic
	NON_REDIRECTABLE_PATHS: ['/register'],
	AD_UNIT_TYPES: {
		DEFAULT: 'DEFAULT',
		BACKFILL: 'BACKFILL',
		NOMCM: 'NOMCM'
	},
	GAMIDS: { AP_GAM_ID: '103512698' },
	GAM_KEYS : {
		INSTREAM_VARIATION: 'instream_variation'
	},
	CONFIG_SYNC_MODES: {
		DFP_SYNC: 'DFP_SYNC',
		SYNC: 'SYNC',
		SYNC_ALL: 'SYNC_ALL',
		SYNC_SELECTED: 'SYNC_SELECTED'
	},
	MISCELLANEOUS_INST_PROPERTIES: {
		NETWORK_DATA_PROPERTIES: {
			COMPANION_AD_FEATURE_CONSTANTS: {
				COMPANION_OBJECT_NAME: 'apCompanionAds',
				COMPANION_AD_KEY: 'Companion Ads'
			},
			OVERLAY_AD_FEATURE_CONSTANTS: {
				OVERLAY_OBJECT_NAME: 'apOverlayAds',
				OVERLAY_AD_KEY: 'Overlay Ads'
			}
		}
	},
	ACCESS_CONTROL_CONSTANTS: {
		SYSTEMS: {
			FRAMERATE: 'FRAMERATE',
			HOME_PAGE: 'HOME_PAGE',
			BANNER_FP: 'BANNER_FP',
			SPLIT_DOC: 'SPLIT_DOC',
			FVP_PLAYER: 'FVP_PLAYER'
		},
		UI_ACCESS: {
			HIDE: 'HIDE',
			DISABLE: 'DISABLE',
			VISIBLE: 'VISIBLE'
		},
		TYPES: {
			INPUT_NAMES: 'INPUT_NAMES',
			BUTTON_NAMES: 'BUTTON_NAMES',
			TAB_NAMES: 'TAB_NAMES',
			SETTING_NAMES: 'SETTING_NAMES',
			ACCORDION_NAMES: 'ACCORDION_NAMES',
			CLIENT_ROUTES: 'CLIENT_ROUTES',
			HEADING_NAMES: 'HEADING_NAMES'
		},
		ACCESS_CONTROL_STRINGS: {
			FVP_READ_WRITE: 'FVP_READ_WRITE',
			SELF_STREAM_READ_WRITE: 'SELF_STREAM_READ_WRITE',
			EXPERIMENT_OVERVIEW_READ: 'EXPERIMENT_OVERVIEW_READ',
			EXPERIMENTAL_FEATURES: 'EXPERIMENTAL_FEATURES'
		}
	},
	CONTENT_MAPPING: {
		VIDEO_CONTENT_MODES: {
			CUSTOM_VIDEOS: 'CUSTOM VIDEOS',
			YOUTUBE_VIDEOS: 'YOUTUBE VIDEOS'
		},
		VIDEO_CONFIG_IDENTIFIERS: {
			VIDEO_CONFIG_CUSTOM: 'VIDEO_CONFIG.CUSTOM',
			VIDEO_CONFIG_YOUTUBE: 'VIDEO_CONFIG.YOUTUBE'
		},
		VIDEO_CONTENT_STATUS: {
			INITIALISED: 'INITIALISED',
			PROCESSED: 'PROCESSED',
			FAILED: 'FAILED'
		},
		YT_MAPPING_MODES: ['MAP_YT_PLAYLIST', 'MAP_YT_LATEST_VIDEO'],
		UPDATE_PLAYLIST: 'UPDATE_PLAYLIST'
	},
	PLACEMENT: {
		INSTREAM: '1',
		ACCOMPANYING: '2',
		INTERSTITIAL: '3',
		STANDALONE: '4'
	},
	VIDEO_PLAYER_SIZES: {
		MIN_HEIGHT: 144,
		MIN_WIDTH: 256
	},
	PULL_AND_MERGE_STATUS: {
		SUCCESS: 'SUCCESS',
		FAILED: 'FAILED'
	},
	FALLBACK_TAG_CONFIG: {
		TAG_CONTENT: 'featuresData.fallbackTagConfig.fallbackTagDetails.tagContent',
		TAG_TYPE: 'featuresData.fallbackTagConfig.fallbackTagType',
		TYPES: {
			SCRIPT: 'SCRIPT',
			HTML: 'HTML'
		}
	},
	VIDEO_TRANSCODING_STATUS: {
		TRANSCODED: 'TRANSCODED',
		FAILED: 'FAILED',
		PROCESSING: 'PROCESSING',
		NOT_TRANSCODED: 'NOT_TRANSCODED'
	},
	VIDEO_TRANSCODE_POLLING_RETRY_INTERVAL: 5000,
	AZURE_VIDEO_UPLOADING_STATUS: {
		UPLOAD: 'UPLOAD',
		UPLOADING: 'UPLOADING',
		UPLOADED: 'UPLOADED'
	},
	AUDIO_VERSION: {
		MUTED: 'muted',
		UNMUTED: 'unmuted'
	},
	FRONTEND_DASHBOARDS: {
		FRAMERATE_DEFAULT_DASHBOARD: 'FRAMERATE_DEFAULT_DASHBOARD',
		SELFSTREAM_DASHBOARD: 'SELFSTREAM_DASHBOARD'
	},
	VAST_TAG_CONSTANTS: {
		BASE_URL: 'https://pubads.g.doubleclick.net/gampad/ads',
		KEYS: {
			ENV: 'env',
			SZ: 'sz',
			IU: 'iu',
			DESCRIPTION_URL: 'description_url',
			TFCD: 'tfcd',
			IMPL: 'impl',
			NPA: 'npa',
			NOFB: 'nofb',
			GDFP_REQ: 'gdfp_req',
			CORRELATOR: 'correlator',
			UNVIEWED_POSITION_START: 'unviewed_position_start',
			CUSTOM_PARAMS: 'cust_params',
			OUTPUT: 'output',
			VAD_TYPE: 'vad_type',
			FLOOR_PRICE: 'floor_price',
			PRMSIG: 'prmsig',
			MAX_AD_DURATION: 'max_ad_duration'
		},
		VALUES: {
			INSTREAM: 'instream',
			OUTPUT_VAST: 'vast',
			VP: 'vp',
			TFCD: {
				ZERO: '0'
			},
			NPA: {
				ZERO: '0'
			},
			IMPL: {
				S: 's'
			},
			GDFP_REQ: {
				ONE: 1
			},
			UNVIEWED_POSITION_START: {
				ONE: '1'
			},
			NOFB: {
				ONE: '1'
			},
			AD_RULES: {
				ZERO: '0',
				ONE: '1'
			}
		},
		VIDEO_FORMAT_TYPES: ['Linear', 'Non-Linear'],
		VAST_PLAYER_SZ: ['1x1', '375x251', '400x300', '640x360', '640x480', '970x550']
	},
	URLENCODED: {
		ENCODED_AMPERSAND: '%26',
		ENCODED_EQUAL: '%3D',
		ENCODED_PIPE: '%7C'
	},
	SYMBOLS: {
		AMPERSAND: '&',
		EQUAL: '=',
		QUESTION_MARK: '?',
		PIPE: '|'
	},
	PLAY_VIDEO_IN_SEQUENCE_KEY: 'playVideosInSequence',
	PENCIL_FLOAT_POSITIONS: ['left', 'right', 'center'],
	CTA_TYPES: {
		PLAYLIST_URL: 'PLAYLIST_URL',
		SECTION_LVL: 'SECTION_LVL',
		CUSTOM_PLAYLIST_CTA: 'CUSTOM_PLAYLIST_CTA',
		VIDEO_LVL: 'VIDEO_LVL'
	},
	PAGE_LEVEL_VIDEO_CTA: {
		TEXT_MAX_LENGTH: 14,
		HTTP_URL_PREFIX: /^https?:\/\//i,
		URL_WHITESPACE: /\s/
	},
	VIDEO_MIME_TYPES: ['video/mp4', 'application/x-mpegURL'],
	CONFIG_KEYS: {
		AGGRESSIVE_AD_REQ_ENABLED: 'requestStructureData.aggressiveAdRequests.enabled',
		TERMINATE_AD_AFTER_DURATION_ENABLED: 'requestStructureData.terminateAdAfterDuration.enabled',
		BACKPOCKET_AD_START_DELAY_CONFIG_ENABLED:
			'requestStructureData.aggressiveAdRequests.backPocketAdStartDelayConfig.enabled'
	},
	countryCodesList: [
		'DEFAULT',
		'AF',
		'AX',
		'AL',
		'DZ',
		'AS',
		'AD',
		'AO',
		'AI',
		'AQ',
		'AG',
		'AR',
		'AM',
		'AW',
		'AU',
		'AT',
		'AZ',
		'BS',
		'BH',
		'BD',
		'BB',
		'BY',
		'BE',
		'BZ',
		'BJ',
		'BM',
		'BT',
		'BO',
		'BA',
		'BW',
		'BV',
		'BR',
		'IO',
		'BN',
		'BG',
		'BF',
		'BI',
		'KH',
		'CM',
		'CA',
		'CV',
		'KY',
		'CF',
		'TD',
		'CL',
		'CN',
		'CX',
		'CC',
		'CO',
		'KM',
		'CG',
		'CD',
		'CK',
		'CR',
		'CI',
		'HR',
		'CU',
		'CY',
		'CZ',
		'DK',
		'DJ',
		'DM',
		'DO',
		'EC',
		'EG',
		'SV',
		'GQ',
		'ER',
		'EE',
		'ET',
		'FK',
		'FO',
		'FJ',
		'FI',
		'FR',
		'GF',
		'PF',
		'TF',
		'GA',
		'GM',
		'GE',
		'DE',
		'GH',
		'GI',
		'GR',
		'GL',
		'GD',
		'GP',
		'GU',
		'GT',
		'GG',
		'GN',
		'GW',
		'GY',
		'HT',
		'HM',
		'VA',
		'HN',
		'HK',
		'HU',
		'IS',
		'IN',
		'ID',
		'IR',
		'IQ',
		'IE',
		'IM',
		'IL',
		'IT',
		'JM',
		'JP',
		'JE',
		'JO',
		'KZ',
		'KE',
		'KI',
		'KP',
		'KR',
		'KW',
		'KG',
		'LA',
		'LV',
		'LB',
		'LS',
		'LR',
		'LY',
		'LI',
		'LT',
		'LU',
		'MO',
		'MK',
		'MG',
		'MW',
		'MY',
		'MV',
		'ML',
		'MT',
		'MH',
		'MQ',
		'MR',
		'MU',
		'YT',
		'MX',
		'FM',
		'MD',
		'MC',
		'MN',
		'ME',
		'MS',
		'MA',
		'MZ',
		'MM',
		'NA',
		'NR',
		'NP',
		'NL',
		'AN',
		'NC',
		'NZ',
		'NI',
		'NE',
		'NG',
		'NU',
		'NF',
		'MP',
		'NO',
		'OM',
		'PK',
		'PW',
		'PS',
		'PA',
		'PG',
		'PY',
		'PE',
		'PH',
		'PN',
		'PL',
		'PT',
		'PR',
		'QA',
		'RE',
		'RO',
		'RU',
		'RW',
		'SH',
		'KN',
		'LC',
		'PM',
		'VC',
		'WS',
		'SM',
		'ST',
		'SA',
		'SN',
		'RS',
		'SC',
		'SL',
		'SG',
		'SK',
		'SI',
		'SB',
		'SO',
		'ZA',
		'GS',
		'ES',
		'LK',
		'SD',
		'SR',
		'SJ',
		'SZ',
		'SE',
		'CH',
		'SY',
		'TW',
		'TJ',
		'TZ',
		'TH',
		'TL',
		'TG',
		'TK',
		'TO',
		'TT',
		'TN',
		'TR',
		'TM',
		'TC',
		'TV',
		'UG',
		'UA',
		'AE',
		'GB',
		'US',
		'UM',
		'UY',
		'UZ',
		'VU',
		'VE',
		'VN',
		'VG',
		'VI',
		'WF',
		'EH',
		'YE',
		'ZM',
		'ZW',
		'UK'
	],

	COUNTRY_CODE_MAP: {
		AD: 'Andorra',
		AE: 'United Arab Emirates',
		AF: 'Afghanistan',
		AG: 'Antigua and Barbuda',
		AI: 'Anguilla',
		AL: 'Albania',
		AM: 'Armenia',
		AO: 'Angola',
		AQ: 'Antarctica',
		AR: 'Argentina',
		AS: 'American Samoa',
		AT: 'Austria',
		AU: 'Australia',
		AW: 'Aruba',
		AX: 'Åland Islands',
		AZ: 'Azerbaijan',
		BA: 'Bosnia and Herzegovina',
		BB: 'Barbados',
		BD: 'Bangladesh',
		BE: 'Belgium',
		BF: 'Burkina Faso',
		BG: 'Bulgaria',
		BH: 'Bahrain',
		BI: 'Burundi',
		BJ: 'Benin',
		BL: 'Saint Barthélemy',
		BM: 'Bermuda',
		BN: 'Brunei Darussalam',
		BO: 'Bolivia (Plurinational State of)',
		BR: 'Brazil',
		BS: 'Bahamas',
		BT: 'Bhutan',
		BV: 'Bouvet Island',
		BW: 'Botswana',
		BY: 'Belarus',
		BZ: 'Belize',
		CA: 'Canada',
		CC: 'Cocos (Keeling) Islands',
		CD: 'Congo, Democratic Republic of the',
		CF: 'Central African Republic',
		CG: 'Congo',
		CH: 'Switzerland',
		CI: "Côte d'Ivoire",
		CK: 'Cook Islands',
		CL: 'Chile',
		CM: 'Cameroon',
		CN: 'China',
		CO: 'Colombia',
		CR: 'Costa Rica',
		CU: 'Cuba',
		CV: 'Cabo Verde',
		CX: 'Christmas Island',
		CY: 'Cyprus',
		CZ: 'Czechia',
		DE: 'Germany',
		DJ: 'Djibouti',
		DK: 'Denmark',
		DM: 'Dominica',
		DO: 'Dominican Republic',
		DZ: 'Algeria',
		EC: 'Ecuador',
		EE: 'Estonia',
		EG: 'Egypt',
		EH: 'Western Sahara',
		ER: 'Eritrea',
		ES: 'Spain',
		ET: 'Ethiopia',
		FI: 'Finland',
		FJ: 'Fiji',
		FM: 'Micronesia (Federated States of)',
		FO: 'Faroe Islands',
		FR: 'France',
		GA: 'Gabon',
		GB: 'United Kingdom of Great Britain and Northern Ireland',
		GD: 'Grenada',
		GE: 'Georgia',
		GF: 'French Guiana',
		GG: 'Guernsey',
		GH: 'Ghana',
		GI: 'Gibraltar',
		GL: 'Greenland',
		GM: 'Gambia',
		GN: 'Guinea',
		GP: 'Guadeloupe',
		GQ: 'Equatorial Guinea',
		GR: 'Greece',
		GT: 'Guatemala',
		GU: 'Guam',
		GW: 'Guinea-Bissau',
		GY: 'Guyana',
		HK: 'Hong Kong',
		HM: 'Heard Island and McDonald Islands',
		HN: 'Honduras',
		HR: 'Croatia',
		HT: 'Haiti',
		HU: 'Hungary',
		ID: 'Indonesia',
		IE: 'Ireland',
		IL: 'Israel',
		IM: 'Isle of Man',
		IN: 'India',
		IO: 'British Indian Ocean Territory',
		IQ: 'Iraq',
		IR: 'Iran (Islamic Republic of)',
		IS: 'Iceland',
		IT: 'Italy',
		JE: 'Jersey',
		JM: 'Jamaica',
		JO: 'Jordan',
		JP: 'Japan',
		KE: 'Kenya',
		KG: 'Kyrgyzstan',
		KH: 'Cambodia',
		KI: 'Kiribati',
		KM: 'Comoros',
		KN: 'Saint Kitts and Nevis',
		KP: "Korea (Democratic People's Republic of)",
		KR: 'Korea, Republic of',
		KW: 'Kuwait',
		KY: 'Cayman Islands',
		KZ: 'Kazakhstan',
		LA: "Lao People's Democratic Republic",
		LB: 'Lebanon',
		LC: 'Saint Lucia',
		LI: 'Liechtenstein',
		LK: 'Sri Lanka',
		LR: 'Liberia',
		LS: 'Lesotho',
		LT: 'Lithuania',
		LU: 'Luxembourg',
		LV: 'Latvia',
		LY: 'Libya',
		MA: 'Morocco',
		MC: 'Monaco',
		MD: 'Moldova, Republic of',
		ME: 'Montenegro',
		MG: 'Madagascar',
		MH: 'Marshall Islands',
		MK: 'North Macedonia',
		ML: 'Mali',
		MM: 'Myanmar',
		MN: 'Mongolia',
		MO: 'Macao',
		MP: 'Northern Mariana Islands',
		MQ: 'Martinique',
		MR: 'Mauritania',
		MS: 'Montserrat',
		MT: 'Malta',
		MU: 'Mauritius',
		MV: 'Maldives',
		MW: 'Malawi',
		MX: 'Mexico',
		MY: 'Malaysia',
		MZ: 'Mozambique',
		NA: 'Namibia',
		NC: 'New Caledonia',
		NE: 'Niger',
		NF: 'Norfolk Island',
		NG: 'Nigeria',
		NI: 'Nicaragua',
		NL: 'Netherlands',
		NO: 'Norway',
		NP: 'Nepal',
		NR: 'Nauru',
		NU: 'Niue',
		NZ: 'New Zealand',
		OM: 'Oman',
		PA: 'Panama',
		PE: 'Peru',
		PF: 'French Polynesia',
		PG: 'Papua New Guinea',
		PH: 'Philippines',
		PK: 'Pakistan',
		PL: 'Poland',
		PM: 'Saint Pierre and Miquelon',
		PN: 'Pitcairn',
		PR: 'Puerto Rico',
		PS: 'Palestine, State of',
		PT: 'Portugal',
		PW: 'Palau',
		PY: 'Paraguay',
		QA: 'Qatar',
		RE: 'Réunion',
		RO: 'Romania',
		RS: 'Serbia',
		RU: 'Russian Federation',
		RW: 'Rwanda',
		SA: 'Saudi Arabia',
		SB: 'Solomon Islands',
		SC: 'Seychelles',
		SD: 'Sudan',
		SE: 'Sweden',
		SG: 'Singapore',
		SH: 'Saint Helena, Ascension and Tristan da Cunha',
		SI: 'Slovenia',
		SJ: 'Svalbard and Jan Mayen',
		SK: 'Slovakia',
		SL: 'Sierra Leone',
		SM: 'San Marino',
		SN: 'Senegal',
		SO: 'Somalia',
		SR: 'Suriname',
		ST: 'Sao Tome and Principe',
		SV: 'El Salvador',
		SY: 'Syrian Arab Republic',
		SZ: 'Eswatini',
		TC: 'Turks and Caicos Islands',
		TD: 'Chad',
		TF: 'French Southern Territories',
		TG: 'Togo',
		TH: 'Thailand',
		TJ: 'Tajikistan',
		TK: 'Tokelau',
		TL: 'Timor-Leste',
		TM: 'Turkmenistan',
		TN: 'Tunisia',
		TO: 'Tonga',
		TR: 'Türkiye',
		TT: 'Trinidad and Tobago',
		TV: 'Tuvalu',
		TW: 'Taiwan, Province of China',
		TZ: 'Tanzania, United Republic of',
		UA: 'Ukraine',
		UG: 'Uganda',
		UM: 'United States Minor Outlying Islands',
		US: 'United States of America',
		UY: 'Uruguay',
		UZ: 'Uzbekistan',
		VA: 'Holy See',
		VC: 'Saint Vincent and the Grenadines',
		VE: 'Venezuela (Bolivarian Republic of)',
		VG: 'Virgin Islands (British)',
		VI: 'Virgin Islands (U.S.)',
		VN: 'Viet Nam',
		VU: 'Vanuatu',
		WF: 'Wallis and Futuna',
		WS: 'Samoa',
		YE: 'Yemen',
		YT: 'Mayotte',
		ZA: 'South Africa',
		ZM: 'Zambia',
		ZW: 'Zimbabwe',
		UK: 'United Kingdom',
		FK: 'Falkland Islands (Malvinas)',
		AN: 'Netherlands Antilles',
		GS: 'South Georgia and the South Sandwich Islands'
	},
	OPTIMIZED_TPV_CONFIG_KEYS: {
		OPTIMIZED_TPV_KEY: 'featuresData.vastDaisyChainingOptimizedConfig',
		OPTIMIZED_TPV_ENABLED:
			'featuresData.vastDaisyChainingOptimizedConfig.optimizedTpvRequests.enabled',
		OPTIMIZED_TPV_MAX_CAPACITY:
			'featuresData.vastDaisyChainingOptimizedConfig.optimizedTpvRequests.maxBackPocketAdsCapacity',
		VAST_DAISY_CHAINING_CONFIG: 'featuresData.vastDaisyChainingConfig',
		AGGRESSIVE_ADS_ENABLED: 'requestStructureData.aggressiveAdRequests.enabled'
	},
	FLOOR_PRICE_MODERATOR_OPTIMIZED_CONFIG: {
		engineType: 'FTGUC_Model',
		experimentNumber: 'inc_dec_2step_mul',
		fillThreshold: 1,
		floorAdjustSteps: {
			decrement: 2,
			increment: 1
		},
		incDecEnabled: true,
		floorDecreaserAndLooperEnabled: false,
		initialFloorMultiplier: {
			DEFAULT: 1
		},
		splitPercentage: 100,
		unfillThreshold: 3
	},
	GAM_GPT_1X1_KEYS: {
		ADPUSHUP_GPT_1X1_TAG: 'ap_tag',
		INSTREAM_GPT_1X1_TAG: 'instream',
		GPT_1X1_TAG: 'GPT_1X1_TAG'
	},
	GPT_1X1_TAG_DROPDOWN_LIST: [
		{
			label: 'USE DIRECT INSTREAM TAG',
			value: 'instream'
		},
		{
			label: 'USE CUSTOM AP TAG (RECOMMENDED)',
			value: 'ap_tag'
		}
	],
	PRESET_FLOORS_SERIES: {
		preset1: [
			'3.00',
			'2.75',
			'2.50',
			'2.00',
			'1.75',
			'1.50',
			'1.25',
			'1.00',
			'0.75',
			'0.60',
			'0.50',
			'0.35',
			'0.30',
			'0.25',
			'0.20',
			'0.15',
			'0.13',
			'0.10',
			'0.06'
		],
		preset2: [
			'5.00',
			'4.50',
			'4.00',
			'3.50',
			'3.25',
			'3.00',
			'2.75',
			'2.50',
			'2.00',
			'1.75',
			'1.50',
			'1.25',
			'1.00',
			'0.75',
			'0.60',
			'0.50',
			'0.35',
			'0.30',
			'0.25',
			'0.20',
			'0.15',
			'0.13',
			'0.10',
			'0.06'
		],
		custom: []
	},
	SERIES_EXPERIMENT_MAP: {
		preset1: 'floor_series1',
		preset2: 'floor_series2',
		custom: 'floor_series_cust'
	}
};
